import Oidc, { UserManagerSettings, WebStorageStateStore } from "oidc-client";
import { SSO_AUTHORITY, SSO_CLIENT_ID } from "../environmentVariables";

// See configuration documentation: https://github.com/IdentityModel/oidc-client-js/wiki

const OIDC_REDIRECT_PATH = "/sso-callback";
const OIDC_SILENT_RENEW_PATH = "/sso-silent-renew";
const OIDC_POST_LOGOUT_PATH = "/sso-logout";

function createUri(path: string) {
    return window.location.protocol + "//" + window.location.host + path;
}

const userManagerConfig: UserManagerSettings = {
    client_id: SSO_CLIENT_ID,
    redirect_uri: createUri(OIDC_REDIRECT_PATH),
    response_type: "code",
    scope: "openid",
    authority: SSO_AUTHORITY,
    silent_redirect_uri: createUri(OIDC_SILENT_RENEW_PATH),
    post_logout_redirect_uri: createUri(OIDC_POST_LOGOUT_PATH),
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    monitorSession: true,
    popupWindowFeatures:
        "location=no,toolbar=no,width=500,height=600,left=300,top=250"
};

const userManager = new Oidc.UserManager(userManagerConfig);

Oidc.Log.logger = console;
Oidc.Log.level = Oidc.Log.WARN;

export {
    userManager,
    OIDC_REDIRECT_PATH,
    OIDC_SILENT_RENEW_PATH,
    OIDC_POST_LOGOUT_PATH
};
